<template>
  <div>
        <h1>{{tituloh1}}</h1>
        <div class="my-3">
            <div class="alert alert-info">
                Para dar inicio al proceso de firma electrónica de un contrato, se deben cumplir las siguientes condiciones:
                <ul>
                    <li>La HOJA DE VALIDACION <strong>ha sido aprobada</strong> (por quien proceda)</li>
                    <li>El <strong>cliente ha aceptado</strong> de forma explícita el método de firma electrónica, empleando para ello nuestro proveedor de servicios de firma electrónica (Signaturit)</li>
                    <li>Se conoce el <strong>nombre y correo electrónica</strong> de la persona que firmará por parte del cliente</li>
                </ul>
            </div>
            <b-card>
                <b-form-group
                    class="mb-4"
                    label-cols-lg="3"
                    
                    label-class="font-weight-bold pt-0"
                    label="Datos del expediente"
                    description="">
                    <b-input-group prepend="Código" class="mb-2">
                        <b-form-input
                            id="codigo"
                            v-model="codigo"
                            :state="codigoState"
                            aria-describedby="input-live-help input-live-feedback"
                            placeholder="Indica el código del expediente"
                            trim
                        ></b-form-input>
                    </b-input-group>                    
                </b-form-group>

                <b-form-group
                    class="mb-4"
                    label-cols-lg="3"
                    
                    label-class="font-weight-bold pt-0"
                    label="Hoja de validación"
                    label-for="file"
                    description=""
                >
                    <b-input-group prepend="Fichero" class="mb-2">               
                        <b-form-file
                            id="file" :ref="'file'"
                            placeholder = "Selecciona un fichero en tu equipo"
                            browseText = "Buscar"
                                accept=".pdf"
                            v-on:change="handleFileUpload()"></b-form-file>  
                    </b-input-group>
                </b-form-group>

                <b-form-group
                    class="mb-4"
                    label-cols-lg="3"
                    
                    label-class="font-weight-bold pt-0"
                    label="Quién firma por Manusa"
                    description="">
                    <b-form-radio-group
                        id="radio-firmantemanusa"
                        name="radio-firmantemanusa"
                        v-model="firmantemanusa"
                        :options="optFirmantesManusa"
                        stacked
                    ></b-form-radio-group>
                </b-form-group>
                <b-form-group
                    class="mb-4"
                    label-cols-lg="3"
                    
                    label-class="font-weight-bold pt-0"
                    label="Quién firma por Cliente"
                    description="">
                    <b-input-group prepend="Nombre" class="mb-2">
                        <b-form-input
                            id="firmantecliente_nombre"
                            v-model="firmantecliente_nombre"
                            :state="firmantecliente_nombreState"
                            aria-describedby="input-live-help input-live-feedback"
                            placeholder="Indica el nombre de la persona que firmará"
                            trim
                        ></b-form-input>
                    </b-input-group>                    
                    <b-input-group prepend="EMail" class="mb-2">
                        <b-form-input
                            id="firmantecliente_email"
                            v-model="firmantecliente_email"
                            :state="firmantecliente_emailState"
                            aria-describedby="input-live-help input-live-feedback"
                            placeholder="Indica el correo electrónico de la persona que firmará"
                            trim
                        ></b-form-input>
                    </b-input-group>
                    
                </b-form-group>
            </b-card>
        </div>

        <div class="w-100 d-flex justify-content-between mb-4">            
            <b-button :disabled="procesandofichero" @click="pasoatras" variant="danger">
                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                Atrás
            </b-button>
            <b-button :disabled="!sepuedecontinuar" @click="siguientepaso" class="bgcolor-manusa">
                Siguiente
                <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
            </b-button>
        </div>
  </div>
</template>

<script>
    export default {
        props: {
            tituloh1: {
                type: String,
                default: "Sube el PDF del contrato que se va a enviar a firmar por via electrónica"
            },
        },
        data() {
            return {
                titulo: "",
                file: "",
                codigo: "",
                ficheroseleccionado: false,
                procesandofichero: false,
                firmantemanusa: 'josep.medina@manusa.com',
                firmantecliente_nombre: "",
                firmantecliente_email: "",
                optFirmantesManusa: [
                    { text: 'Josep Medina - Director General de Grupo Manusa', value: 'josep.medina@manusa.com' },
                    //{ text: 'Iñigo Beitia - Responsable Comercial', value: 'i.beitia@manusa.com' },
                    { text: 'Alex Araguz - Responsable Cataluña', value: 'alex.araguz@manusa.com' },
                    { text: 'Cesar Alvarez - Responsable Centro', value: 'cesar.alvarez@manusa.com' },
                    { text: 'Jose Luis Ortega - Responsable Baleares', value: 'joseluis.ortega@manusa.com' },
                    { text: 'Juan Carlos Galan - Responsable Galicia', value: 'juancarlos.galan@manusa.com' },
                    { text: 'Manuel Toja - Responsable Asturias', value: 'manuel.toja@manusa.com' },
                ],
                firmantesposibles: {
                    "josep.medina@manusa.com": { "cargo": "Director General de Grupo Manusa", "nombre": "Josep Medina" },
                    "i.beitia@manusa.com": { "cargo": "Director Comercial de Grupo Manusa", "nombre": "Iñigo Beitia" },
                    "alex.araguz@manusa.com": { "cargo": "Responsable Comercial, Cataluña", "nombre": "Alex Araguz" },
                    "cesar.alvarez@manusa.com": { "cargo": "Responsable Comercial, Centro", "nombre": "Cesar Alvarez" },
                    "joseluis.ortega@manusa.com": { "cargo": "Responsable Comercial, Baleares", "nombre": "Jose Luis Ortega" },
                    "juancarlos.galan@manusa.com": { "cargo": "Responsable Comercial, Galicia", "nombre": "Juan Carlos Galan" },
                    "manuel.toja@manusa.com": { "cargo": "Responsable Comercial, Asturias", "nombre": "Manuel Toja" },
                }
            }
        },
        methods: {            
            /**
             * @description: Trigger que se ejecuta cuando se selecciona un nuevo documento, con el fin de extraer el título del documento
             */
            handleFileUpload() {
                this.file = this.$refs.file.$refs.input.files[0];
                this.titulo = this.file.name.split(".")[0]
            },
            siguientepaso() {
                this.procesandofichero = true
                //Preparación de los datos
                var _t = this
                //this.axios.defaults.baseURL = process.env.VUE_APP_API_URL
                var formData = new FormData();
                formData.append('hojavalidacion', this.file)
                formData.append('codigo', this.codigo)
                formData.append('firmantemanusa_email', this.firmantemanusa)
                formData.append('firmantemanusa_nombre', this.firmantesposibles[this.firmantemanusa].nombre)
                formData.append('firmantemanusa_cargo', this.firmantesposibles[this.firmantemanusa].cargo)
                formData.append('firmantecliente_nombre', this.firmantecliente_nombre)
                formData.append('firmantecliente_email', this.firmantecliente_email)
                
                this.axios.post("efirma/activar-expediente-contrato", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${process.env.VUE_APP_CLAVEAPIEFIRMA}`
                    },
                })
                .then(function (response) {
                    //console.log("Respuesta API", response.data)
                    if (response.data.error==="") {
                        //_t.urlpdf = "data:application/pdf;base64,"+response.data.contenidopdf                
                        _t.$emit('expediente-activado', response.data.datosexpediente, response.data.pdfhojavalidacion)
                    }
                    // console.log(_t.urlpdf)
                    // var pdfAsArray = convertDataURIToBinary(_t.urlpdf)
                    // _t.srcpdf = pdf.createLoadingTask(pdfAsArray)
                    // _t.srcpdf.promise.then(pdf => {
                    //     console.log("pdf", pdf)
                    //     _t.numPages = pdf.numPages;
                    //     if (_t.numPages<4) _t.estilooverflow = "overflow-y: hidden;"
                    // });
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    _t.procesandofichero = false
                    // always executed
                })
            },
            pasoatras() {
                this.$emit('paso-atras')
            },
        },
        watch: {
            titulo(newValue) {  //, oldValue
                this.ficheroseleccionado=newValue.length>0
            }
        },
        computed: {
            firmantecliente_nombreState() {
                return (this.firmantecliente_nombre.length>5)
            },
            firmantecliente_emailState() {
                return (this.firmantecliente_email.length>5)
            },
            codigoState() {
                return (this.codigo.length>10)
            },
            sepuedecontinuar() {
                return (this.ficheroseleccionado && !this.procesandofichero && this.firmantecliente_nombreState && this.firmantecliente_emailState && this.codigoState)
            }
        }
    }
</script>